import { forwardRef } from 'react';
import type { BasicInputProps } from '../basic-input';
import { BasicInput } from '../basic-input';

type PasswordInputProps = Omit<BasicInputProps, 'type'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (props, ref) => <BasicInput ref={ref} type="password" {...props} />
);

PasswordInput.displayName = 'PasswordInput';
